<script>
import options from './ActiveRoleListCard.options'
export default options
</script>

<template>
  <article class="kb-active-role-list-card">

      <div class="kb-active-role-list-card__wrapper-left kb-active-role-list-card--content-padding">
        
        <h3 class="kb-active-role-list-card__text-title">{{ roleCardData.activityName }}</h3>

        <div class="kb-active-role-list-card__text-wrapper">
          <p class="kb-active-role-list-card__text-role-data">{{ roleCardData.roleName }}</p>
          <!-- // if location added to design - pile as divider? -->
          <span>|</span>
          <p class="kb-active-role-list-card__text-role-data">{{ roleCardData.groupName }}</p>
        </div>

      </div>

      <template v-if="!roleCardData.isApproved">
        <div class="kb-active-role-list-card__label">
          {{ getLabel("pendingApprovalLabel") }}
        </div>
      </template>
      
      <div class="kb-active-role-list-card__wrapper-right">

          <button @click="startDeleteRoleOverlay" aria-haspopup="true" class="kb-active-role-list-card__delete-role kb-link kb-active-role-list-card--content-padding kb-active-role-list-card--content-padding-lower">
            {{ getLabel("removeLinkLabel") }}
          </button>   
     
      </div>

  </article>
</template>
